/* 首頁 */
export const ROOT_PAGE_HOME = '/';

/* 服務 */
export const ROOT_PAGE_SERVICE = '/service';

/* 專案 */
export const ROOT_PAGE_PROJECT = '/project';

/* 專案 : 第一層 */
export const PAGE_PROJECT_OVERVIEW = '/overview';
export const PAGE_PROJECT_DETAIL = '/:id';

/* 聯絡我們 */
export const ROOT_PAGE_CONTACT = '/contact';

/* 使用者登入 */
export const ROOT_PAGE_SIGN_IN = '/login';
